import { title } from 'process';
import { AnswersLinks, AnswersOptions, AnswersQuestions } from './../shared/model-service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-btn-save',
  templateUrl: './btn-save.component.html',
  styleUrls: ['./btn-save.component.css']
})
export class BtnSaveComponent implements OnInit {

  @Output() saveEventEmitter: EventEmitter<any> = new EventEmitter();
  @Input() surveyEnd: boolean;
  @Input() currentSurvey: any;

  constructor() { }

  ngOnInit(): void {

  }

  save() {
    // increment pour creer des temporary Id différentes
    var loop = 1;

    //création du servey answer
    var surveyAnswer: any = {
      SessionId: null,
      Date: new Date(),
      AnswerQuestions: []
    }

    this.currentSurvey.questions.forEach(question => {
      var answerQuestion: AnswersQuestions = {
        QuestionId: question.id,
        Title: question.title,
        Unit: question.unit,
        Type: question.type,
        DisplayMode: question.displayMode,
        DisplayDateMode: question.displayDateMode,
        DisplayLengthOfTimeMode: question.displayLengthOfTimeMode,
        TemporaryId: loop.toString(),
        AnswerOptions: [],
      }

      // Yes or No / Unique Choice / Smiley
      if (question.type == 8 || question.type == 2 || question.type == 5) {
        question.options.forEach(option => {
          if (question.result == option.title) {
            this.createAnswerOptionAndLinks(answerQuestion, option, option.title, null);
          }
        });
      }
      // multiple choices
      else if (question.type == 1) {
        question.options.forEach(option => {
          if (option.result != null) {
            this.createAnswerOptionAndLinks(answerQuestion, option, option.title, null);
          }
        })
      }
      // quantité choix unique / quantité plus/moins 
      else if (question.type == 3 && question.displayMode == 2 || question.type == 3 && question.displayMode == 0) {
        question.options.forEach(option => {
          if (option.result != null) {
            this.createAnswerOptionAndLinks(answerQuestion, option, option.title, option.result);
          }
        });
      }
      // quantite slider / quantité nombre / durée de temps / année / heure
      // texte / date
      else {
        // Pour ces types de question, il n'existe forcément qu'une seule option
        var option = question.options[0];

        if (question.type == 4 || question.type == 6 || question.type == 10) {
          var title = option.result;
          var value = null;
        }
        else {
          var title = option.title;
          var value = option.result?.toString();
        }

        this.createAnswerOptionAndLinks(answerQuestion, option, title, value);
      }

      // Ajout de la question dans le questionnaore
      surveyAnswer.AnswerQuestions.push(answerQuestion);
      loop++;
    });

    // Création des ID temporaires afin de conserver le chemin parcouru
    surveyAnswer.AnswerQuestions.forEach(question => {
      question.AnswerOptions.forEach(option => {
        option.AnswerLinks.forEach(link => {
          var result = surveyAnswer.AnswerQuestions.find(x => x.QuestionId == link.QuestionId)
          if (result != undefined)
            link.AnswerQuestionTemporaryId = result.TemporaryId;
        });
      });
    });

    this.saveEventEmitter.emit(surveyAnswer)
    console.log(surveyAnswer);
  }

  /** Créé les AnswerOptions et les AnswerLinks */
  createAnswerOptionAndLinks(answerQuestion, option, title, value) {
    var valueString = ""+value;
    var answerOption: AnswersOptions = {
      OptionId: option.id.toString(),
      Title: title,
      Value: valueString,
      AnswerLinks: []
    }
    
    option.links.forEach(element => {
      var answerLink: AnswersLinks = {
        SurveyLinkId: element.id,
        criticity: element.criticity,
        surveyActionDestinationId: element.actionDestinationId,
        tipDestinationId: element.tipDestinationTipId,
        popupDestinationId: element.popupDestinationId,
        AnswerQuestionTemporaryId: null,
        QuestionId: element.questionDestinationId,
      }
      answerOption.AnswerLinks.push(answerLink);
    });
    answerQuestion.AnswerOptions.push(answerOption)
  }

  hasNumber(myString) {
    return /\d/.test(myString);
  }
}
